/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    CALL_TO_TRIGGER_VALIDATE_ORDER,
    SKIP_VALIDATE_CART,
    TRIGGER_VALIDATE_ORDER,
    TRIGGER_VALIDATE_ORDER_COMPLETED,
} from './ValidateCart-ActionTypes';

export const callToTriggerValidateOrder = (history, billingAddressForm, pageType) => ({
    type: CALL_TO_TRIGGER_VALIDATE_ORDER,
    history,
    billingAddressForm,
    pageType,
});

export const triggerValidateOrder = (history, billingAddressForm, pageType) => ({
    type: TRIGGER_VALIDATE_ORDER,
    history,
    billingAddressForm,
    pageType,
});

export const triggerValidateOrderCompleted = (status) => ({
    type: TRIGGER_VALIDATE_ORDER_COMPLETED,
    status,
});

export const setSkipValidateCart = (data) => ({
    type: SKIP_VALIDATE_CART,
    data,
});
